<template>
  <div class="academic-landing">
    <section class="section intro" v-once>
      <div class="container">
        <div class="row">
          <div class="col-md-5 white text-center text-sm-left">
            <h1 class="m-t-0 m-b-lg">A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments</h1>
            <div class="m-b">
              <app-links :appLinks="links"/>
            </div>
            <p class="m-b-lg">Approved by the Colleges of Medicine South Africa</p>

          </div>
        </div>
      </div>
    </section>

    <section class="section p-y-md" v-once>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 text-center">
            <h3 class="m-t-0">Supported Specialities</h3>
            <div class="label-tags text-center m-y-lg">
              <div v-for="(speciality, idx) in specialities" :key="idx">
                {{ speciality }}
              </div>
            </div>
            <p class="m-b-0">More Specialities coming soon...</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section benefits" v-once>
      <div class="container">
        <div class="row m-b-lg">
          <div class="col-md-12 text-center">
            <h2>LogBox Academic Benefits</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 text-left">
            <ul class="feature-list icon-left">
              <li>
                <i class="fa fa-university"></i>
                <h3>Integrate with your<br>academic institution</h3>
                <p>Endorsed by the Colleges of Medicine of South Africa and links directly to your training institution.</p>
              </li>

              <li>
                <i class="fa fa-user"></i>
                <h3>CV and Academic<br>training history</h3>
                <p>Record your academic progress in a well structured format.</p>
              </li>

              <li>
                <i class="fa fa-pencil-square-o"></i>
                <h3>Sign off your<br>rotations electronically</h3>
                <p>Supervisors and Heads of Departments can electronically approve your rotations.</p>
              </li>

              <li>
                <i class="fa fa-lock"></i>
                <h3>Absolute<br>Privacy</h3>
                <p>Feel secure by setting up either a unique code or setup biometric access.</p>
              </li>
            </ul>
          </div>
          <div class="col-md-4 text-center hidden-xs">
            <img src="~assets/images/splash-main6.png" class="img-responsive">
          </div>
          <div class="col-md-4 text-left">
            <ul class="feature-list icon-left">
              <li>
                <i class="fa fa-file"></i>
                <h3>Logbook<br>Reports</h3>
                <p>Easily export your de-identified procedure reports to Excel and PDF documents.</p>
              </li>

              <li>
                <i class="fa fa-cloud-upload"></i>
                <h3>Upload Procedure<br>Photos</h3>
                <p>Upload your photos and file them with the relevant procedure.</p>
              </li>

              <li>
                <i class="fa fa-wifi"></i>
                <h3>Online & Offline<br>Access</h3>
                <p>Log your procedures even when you aren't connected to the internet.</p>
              </li>

              <li>
                <i class="fa fa-cloud"></i>
                <h3>1GB Free<br>Cloud Storage</h3>
                <p>Safe and reliable backup that is accessible from anywhere.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="section devices m-b-0">
      <div class="container">
        <div class="row m-b-l">
          <div class="col-md-12 text-center">
            <h2 class="m-t-0 m-b-lg">LogBox Academic works on all devices</h2>
          </div>
        </div>
        <div class="text-center tabsAct m-b-lg">
          <ul class="list-inline text-center" role="tablist">
            <li role="presentation" :class="{ active: activeTab === 1}" @click="activeTab = 1">
              <button class="btn btn-default btn-lg" href="#android" data-toggle="tab" aria-expanded="true"><i class="fa fa-android fa-2x"></i></button>
            </li>
            <li role="presentation" :class="{ active: activeTab === 2}" @click="activeTab = 2">
              <button class="btn btn-default btn-lg" href="#ios" data-toggle="tab" aria-expanded="false"><i class="fa fa-apple fa-2x"></i></button>
            </li>
            <li role="presentation" :class="{ active: activeTab === 3}" @click="activeTab = 3">
              <button class="btn btn-default btn-lg" href="#pc" data-toggle="tab" aria-expanded="false"><i class="fa fa-desktop fa-2x"></i></button>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane" id="android" :class="{ active: activeTab === 1}">

            <div class="row" v-once>
              <div class="col-md-4 text-center">
                <h3>Secure Access</h3>
                <p class="m-b-lg">Keep your details as well as the details of your patients private by logging in securely.</p>
                <img src="~assets/images/brochure/academic/1.png" class="img-responsive center-block">
              </div>
              <div class="col-md-4 text-center">
                <h3>Procedure Logbook</h3>
                <p class="m-b-lg">Log and review all of your procedures in the list overview section.</p>
                <img src="~assets/images/brochure/academic/2.png" class="img-responsive center-block">
              </div>
              <div class="col-md-4 text-center">
                <h3>Comprehensive Information</h3>
                <p class="m-b-lg">View a comprehensive detailed overview of your past procedures.</p>
                <img src="~assets/images/brochure/academic/3.png" class="img-responsive center-block">
              </div>
            </div>

          </div>
          <div role="tabpanel" class="tab-pane" id="ios" :class="{ active: activeTab === 2}">

            <div class="row" v-once>
              <div class="col-md-4 text-center">
                <h3>Secure Access</h3>
                <p class="m-b-lg">Keep your details as well as the details of your patients private by logging in securely.</p>
                <img src="~assets/images/brochure/academic/4.png" class="img-responsive center-block">
              </div>
              <div class="col-md-4 text-center">
                <h3>Procedure Logbook</h3>
                <p class="m-b-lg">Log and review all of your procedures in the list overview section.</p>
                <img src="~assets/images/brochure/academic/5.png" class="img-responsive center-block">
              </div>
              <div class="col-md-4 text-center">
                <h3>Comprehensive Information</h3>
                <p class="m-b-lg">View a comprehensive detailed overview of your past procedures.</p>
                <img src="~assets/images/brochure/academic/6.png" class="img-responsive center-block">
              </div>
            </div>

          </div>
          <div role="tabpanel" class="tab-pane" id="pc" :class="{ active: activeTab === 3}">

            <div class="row" v-once>
              <div class="col-md-4 text-center">
                <h3>Secure Access</h3>
                <p class="m-b-lg">Keep your details as well as the details of your patients private by logging in securely.</p>
              </div>
              <div class="col-md-4 text-center">
                <h3>Procedure Logbook</h3>
                <p class="m-b-lg">Log and review all of your procedures in the list overview section.</p>
              </div>
              <div class="col-md-4 text-center">
                <h3>Comprehensive Information</h3>
                <p class="m-b-lg">View a comprehensive detailed overview of your past procedures.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <img src="~assets/images/brochure/academic/screen10.png" class="img-responsive center-block">
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section class="" v-once>
      <div class="container-fluid">
        <div class="row flush">
          <div class="col-md-4 grey-1">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Patient</h3>
              <p class="">LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.</p>
              <router-link to="/patient" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-2">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Practice</h3>
              <p class="">Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.</p>
              <router-link to="/practice" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-3">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Academic</h3>
              <p class="">A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.</p>
              <router-link to="/signup" class="btn btn-primary">Sign Up Now</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import PartnerBranding from 'components/common/PartnerBranding';
  import AppLinks from 'components/common/AppLinks';

  export default {
    name: 'academic',
    components: {
      PartnerBranding,
      AppLinks,
    },
    data: () => ({
      activeTab: 1,
      links: {
        andriod: `${process.env.VUE_APP_ACADEMIC_APP_ANDROID}`,
        apple: `${process.env.VUE_APP_ACADEMIC_APP_ISO}`,
      },
      specialities: [
        'Anaesthetics',
        'Cardiothoracic Surgery',
        'General Surgery',
        'Internal Medicine',
        'Maxillo-facial and Oral Surgery',
        'Neurosurgery',
        'Nuclear Medicine',
        'Obstetrics & Gynaecology',
        'Ophthalmology',
        'Orthopaedic Surgery',
        'Otorhinolaryngology',
        'Paediatric Surgery',
        'Plastic Surgery',
        'Psychiatry',
        'Urology',
        'Paediatrics'
      ]
    }),
    mounted() {
      this.$store.dispatch('updateContext', {
        context: 'academic',
      });
    },
  };

</script>



// WEBPACK FOOTER //
// Academic.vue?449558e2